import { useState } from "react";
import { faqList } from "@/mocks/anime";

export default function Faq() {
  const [openId, setOpenId] = useState<string | null>("f01");

  return (
    <section id="faq" className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-3xl px-4 md:px-6">
        <div className="mb-10 text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-700">
            <i className="ri-question-answer-line"></i>
            常见问题
          </span>
          <h2 className="mt-3 font-heading text-3xl text-foreground-950 md:text-4xl">
            关于51动漫网，你可能想问
          </h2>
        </div>

        <div className="space-y-3">
          {faqList.map((item) => {
            const open = openId === item.id;
            return (
              <div
                key={item.id}
                className={`overflow-hidden rounded-2xl border bg-background-50 transition-colors ${
                  open ? "border-accent-300" : "border-background-200/80"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenId(open ? null : item.id)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left md:px-6"
                  aria-expanded={open}
                >
                  <span className="font-heading text-base text-foreground-950">{item.question}</span>
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-all ${
                      open ? "rotate-180 bg-accent-500 text-background-50" : "bg-background-100 text-foreground-600"
                    }`}
                  >
                    <i className="ri-arrow-down-s-line text-lg"></i>
                  </span>
                </button>
                {open && (
                  <div className="border-t border-background-200/70 px-5 py-4 md:px-6">
                    <p className="text-sm leading-relaxed text-foreground-600">{item.answer}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}